/**
 * belgeDurumu.js — Firma Kartı > Evraklar kutucuğunun durum rozeti (backlog #528, 2026-10-21; FirmaKartPage.jsx'ten taşındı ki jest ile
 * denenebilsin).
 *
 * FILE_APPROVAL_STATUS (0=Beklemede / 1=Onaylandı / 2=Reddedildi) kodlu firma belgelerini DocumentTile'ın beklediği {label, color} şekline
 * çevirir; `raw` alanı yükleme butonunun onaylı belgede gizlenmesi için saklanır.
 *
 * Kayıt YOKSA: İSTENEN (`zorunlu`) belge kırmızı, isteğe bağlı belge nötr açık gri. WAS (until #528): her kayıtsız belge `secondary` idi ve bu
 * temada `secondary` TEAL-YEŞİL (rgb 3,131,115), yani eksik bir zorunlu belge yeşil görünüyordu. (Bu temada `success` ise gri.)
 */
import { FILE_APPROVAL_STATUS } from "../../services/projectService";
import i18n from "../../i18n";

export function firmaBelgeStatusInfo(status, zorunlu = false) {
  const info = status != null ? FILE_APPROVAL_STATUS[status] : null;
  if (info) return { ...info, raw: status };
  return { label: i18n.t("portal:firmaKart.kayitYok"), color: zorunlu ? "danger" : "light", raw: null };
}
